import api from './http';

// Reporting enrichi
export const getCollegeDistribution = () => api.get('/reporting/college-distribution');
export const getTopPartners = (limit = 5) => api.get('/reporting/top-partners', { params: { limit } });
export const getMonthlyRecovery = (months = 6) => api.get('/reporting/monthly-recovery', { params: { months } });
export const getTopTerritories = (limit = 5) => api.get('/reporting/top-territories', { params: { limit } });

// Reporting
export const getReportingKpi = () => api.get('/reporting/kpi-summary');
export const getDossiersEvolution = (months = 12) => api.get(`/reporting/dossiers-evolution?months=${months}`);
export const getContributionsTerritoire = () => api.get('/reporting/contributions-territoire');
export const getDossiersType = () => api.get('/reporting/dossiers-type');
export const getPipelineFunnel = () => api.get('/reporting/pipeline-funnel');
export const getChecklistGlobal = () => api.get('/reporting/checklist-global');
export const exportCsv = (entity) => api.get(`/reporting/export/csv?entity=${entity}`, { responseType: 'blob' });
export const previewMonthlyReport = () => api.get('/reporting/monthly-report/preview', { responseType: 'blob' });
export const sendMonthlyReport = () => api.post('/reporting/monthly-report/send');

// Impact ESS ODD
export const getImpactDashboard = (period = 'all') => api.get(`/impact-ess/dashboard?period=${period}`);
export const getOddObjectives = () => api.get('/impact-ess/objectives');
export const saveOddObjectives = (values) => api.put('/impact-ess/objectives', { values });

// Impact Reports (shared links)
export const createSharedReport = (data) => api.post('/impact-reports/share', data);
export const getSharedReports = () => api.get('/impact-reports/shared');
export const deleteSharedReport = (id) => api.delete(`/impact-reports/shared/${id}`);
export const getPublicImpactReport = (token) => api.get(`/public/impact-report/${token}`);

// Impact Org Reports
export const getOrgImpactDashboard = (period = 'all') => api.get(`/impact-ess/org-dashboard?period=${period}`);
export const saveOrgImpactReport = (data) => api.post('/impact-ess/org-report/save', data);
export const listOrgImpactReports = () => api.get('/impact-ess/org-reports');
export const getOrgImpactReport = (id) => api.get(`/impact-ess/org-report/${id}`);
export const deleteOrgImpactReport = (id) => api.delete(`/impact-ess/org-report/${id}`);

// Auto Reports
export const getAutoReportConfig = () => api.get('/auto-reports/config');
export const updateAutoReportConfig = (data) => api.put('/auto-reports/config', data);
export const sendReportNow = () => api.post('/auto-reports/send-now');
export const getAutoReportHistory = () => api.get('/auto-reports/history');

// KPI
export const getKpiDashboard = (year, quarter, dateStart, dateEnd) => {
  const q = new URLSearchParams();
  q.append('year', year || 0);
  q.append('quarter', quarter || 0);
  if (dateStart) q.append('date_start', dateStart);
  if (dateEnd) q.append('date_end', dateEnd);
  return api.get(`/kpi/dashboard?${q.toString()}`);
};
export const getKpiObjectives = (year, quarter) => api.get(`/kpi/objectives?year=${year || 0}&quarter=${quarter || 0}`);
export const setKpiObjectives = (data) => api.post('/kpi/objectives', data);
export const setKpiBulkObjectives = (data) => api.post('/kpi/objectives/bulk', data);
export const getKpiQuarterlyReport = (year, quarter) => api.get(`/kpi/quarterly-report?year=${year || 0}&quarter=${quarter || 0}`);
export const downloadKpiReportPdf = (year, quarter) => api.get(`/kpi/quarterly-report/pdf?year=${year || 0}&quarter=${quarter || 0}`, { responseType: 'blob' });
